"use strict";
/* @ngInject */
function featureService(FEATURE_TOGGLE, FEATURE_TOGGLES, API_URL, $http, $q) {
    return function () {
        var togglesRequests = [];
        var toggles = [];
        // @TODO get toggles states within one request, for now we have only one toggle
        FEATURE_TOGGLES.forEach(function (name) {
            togglesRequests.push($http.get("" + API_URL.toggle.replace(/:name/, name))
                .then(function (response) {
                return response.data;
            })
                .then(function (toggle) {
                toggles.push(toggle);
                FEATURE_TOGGLE[toggle.name] = toggle.enabled;
            }));
        });
        return $q
            .all(togglesRequests)
            .then(function () {
            return toggles;
        });
    };
}
exports.featureService = featureService;



/** WEBPACK FOOTER **
 ** ./app/common/feature/feature.service.ts
 **/